import { MenuTypeType } from "@me-team/host/main/graphql/types";
import { CheckMenuItemAvailabilityForMenuTypeQuery } from "@me-team/host/main/updateMenuItem/graphql/updateMenuItem.hooks";

type AvailabilityCompany = NonNullable<NonNullable<CheckMenuItemAvailabilityForMenuTypeQuery["user"]>["company"]>;
type AvailabilityMenuItemsList = NonNullable<AvailabilityCompany["menuItemsList"]>;
type AvailabilityMenuItem = NonNullable<AvailabilityMenuItemsList[number]>;

const menuTypeAvailabilityFieldMap: Record<
    MenuTypeType,
    "availableDeliveryMenus" | "availableDineInMenus" | "availablePickupMenus"
> = {
    [MenuTypeType.Delivery]: "availableDeliveryMenus",
    [MenuTypeType.DineIn]: "availableDineInMenus",
    [MenuTypeType.Pickup]: "availablePickupMenus",
};

export const getDisabledMenuTypes = (
    initialTypes: MenuTypeType[] = [],
    currentTypes: MenuTypeType[] = []
): MenuTypeType[] => {
    const currentTypesSet = new Set(currentTypes);

    return initialTypes.filter((type) => !currentTypesSet.has(type));
};

export const getConflictingMenuTypes = (
    menuItem: AvailabilityMenuItem | null | undefined,
    disabledTypes: MenuTypeType[] = []
): MenuTypeType[] => {
    if (!menuItem) {
        return [];
    }

    return disabledTypes.filter((type) => {
        const field = menuTypeAvailabilityFieldMap[type];
        return (menuItem[field]?.length ?? 0) > 0;
    });
};

export const getConflictingMenuTypesFromAvailabilityQuery = (
    data: CheckMenuItemAvailabilityForMenuTypeQuery | undefined,
    disabledTypes: MenuTypeType[] = []
): MenuTypeType[] => {
    const menuItem = data?.user?.company?.menuItemsList?.find((item): item is AvailabilityMenuItem => !!item) ?? null;

    return getConflictingMenuTypes(menuItem, disabledTypes);
};
